import { connect } from 'react-redux';
import type { Facet, OverrideValues, AccommodationState, HotelFacet } from '@/interfaces';
import { actions } from '@/state/filterActions';
import { fetchHotels } from '@/ducks/searchResults/actions';
import { type CheckboxDispatchProps, CheckboxFilter, type CheckboxStateProps } from '@/components/checkboxFilter/CheckboxFilter';
import type { ActionCreator } from 'redux';

import displayValues from '../../../../../../assets/displayValues.json';

const popularFacilities = (facilities: readonly HotelFacet[]): number =>
    facilities.filter(
        (facility) =>
            displayValues.features[facility.id] &&
            displayValues.features[facility.id].enabled &&
            displayValues.features[facility.id].priority,
    ).length;

export const mapFacilities = (facilities: readonly HotelFacet[]): readonly Facet[] => {
    const facilitySort = (a: HotelFacet, b: HotelFacet) => {
        const prio1 = displayValues.features[a.id]?.priority ?? Number.MAX_SAFE_INTEGER;
        const prio2 = displayValues.features[b.id]?.priority ?? Number.MAX_SAFE_INTEGER;

        if (prio1 === prio2) {
            return a.name.localeCompare(b.name);
        }
        return prio1 - prio2;
    };

    return facilities
        .filter((facility) => displayValues.features[facility.id] && displayValues.features[facility.id].enabled)
        .sort(facilitySort)
        .map((facility) => ({
            value: facility.id.toString(),
            count: facility.hotelCount,
            displayValue: displayValues.features[facility.id].localisedName ?? facility.name,
        }));
};

export const mapStateToProps = (state: AccommodationState): CheckboxStateProps => ({
    id: 'HotelFacilityFilter',
    label: 'Fasiliteter',
    facetList: mapFacilities(state.searchResults.facilities),
    collapsedSize: Math.max(popularFacilities(state.searchResults.facilities), 3),
    checkboxValues: state.filters.facility,
    hideLabel: true,
});

export const mapDispatchToProps: OverrideValues<CheckboxDispatchProps, ActionCreator<unknown>> = {
    checkBoxClick: actions.filterFacility,
    triggerFetch: fetchHotels,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckboxFilter);
